import Headroom from "headroom.js";
import Header from './header/header';
import HeaderMobile from './header/header-mobile';

document.addEventListener("DOMContentLoaded", () => {
  const waitFor = (time) => new Promise((resolve) => setTimeout(resolve, time));

  const headerEl = document.querySelector('[data-header]');
  if (!headerEl) return;

  let header = null;
  let headerMobile = null;
  let headroom = null;
  let mediaQuery = null;

  /**
   * Initialize header or pause/resume event delegation based on media query.
   * Prevent Headroom from reacting to scroll events when in mobile orientation.
   */
  const handleMediaQueryChange = (e) => {
    if (e.matches) {
      handleChangeDesktop(headerEl);
    } else {
      handleChangeMobile(headerEl);
    }
    handleRecommendationsAnchorOffset();
  };

  const handleChangeDesktop = () => {
    disposeMobileHeader();
    headroom = initializeHeadroom(headerEl);
    headroom.init();
    addHeadroomHandlersForAnchorLink();
    header = new Header({ el: headerEl });
  };

  const handleChangeMobile = () => {
    resetAndDisposeDesktopHeader();
    headerMobile = new HeaderMobile({ el: headerEl });
    if (headroom) {
      removeHeadroomHandlersForAnchorLink();
      headroom.destroy();
      headroom = null;
    }
  };

  const handleRecommendationsAnchorOffset = () => {
    if (urlHasRecommendationsHash()) {
      pinHeader();
      updateRecommendationsAnchorOffset();
    }
  };

  /**
   * Pin the header manually using Headroom API or by adding the class directly
   */
  const pinHeader = () => {
    if (headroom) {
      headroom.pin();
    } else {
      headerEl.classList.add('header--full');
    }
  };

  /**
   * Update the recommendations div offset based on the actual header height
   * This ensures the anchor link scrolls to the right position below the floating header
   */
  const updateRecommendationsAnchorOffset = () => {
    const recommendationsAnchor = document.getElementById('recommendations');
    if (!recommendationsAnchor || !headerEl) return;

    const headerHeight = headerEl.offsetHeight;

    recommendationsAnchor.style.setProperty('--layout--height', `${headerHeight / 10}rem`);
    recommendationsAnchor.style.setProperty('--layout--top', `-${headerHeight / 10}rem`);
  };

  const urlHasRecommendationsHash = () => {
    return window.location.hash === '#recommendations';
  };

  /**
   * Initialize Headroom and add click event listeners to jump link links.
   * Prevent Headroom from reacting to scroll events when a jump link is clicked.
   */
  const initializeHeadroom = (headerEl) => {
    return new Headroom(headerEl, {
      offset: 0,
      tolerance: 12,
      classes: {
        top: "header--top",
        notTop: "header--not-top",
        notBottom: "header--not-bottom",
        unpinned: "header--partial",
        pinned: "header--full",
        bottom: "header--full"
      }
    });
  };

  //Waits for dynamically generated anchor links to be added to the DOM
  const addHeadroomHandlersForAnchorLink = () => {
    waitFor(500).then(() => {
      document.querySelectorAll('main a[href^="#"]').forEach((el) => {
        el.addEventListener('click', handleAnchorLinkClick);
      });
    });
  };

  const removeHeadroomHandlersForAnchorLink = () => {
    document.querySelectorAll('main a[href^="#"]').forEach((el) => {
      el.removeEventListener('click', handleAnchorLinkClick);
    });
  };

  const handleAnchorLinkClick = () => {
    headroom.freeze();
    waitFor(500).then(() => headroom.unfreeze());
  };

  const disposeMobileHeader = () => {
    if (headerMobile) {
      headerMobile.dispose();
      headerMobile = null;
    }
  };

  const resetAndDisposeDesktopHeader = () => {
    if (header) {
      header.resetToInitialState();
      header.dispose();
      header = null;
    }
  };

  // Initial setup
  mediaQuery = window.matchMedia("(min-width: 768px)");
  mediaQuery.addEventListener('change', handleMediaQueryChange);
  handleMediaQueryChange(mediaQuery);
});
